module.exports = __webpack_public_path__ + "img/attribute-class.9da5263e.svg";